// extracted by mini-css-extract-plugin
export default {"wrapper":"OtherRanksTooltip__wrapper___lLwT6","img":"OtherRanksTooltip__img___EYjpR","icon":"OtherRanksTooltip__icon___RDMfl"};